var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('el-row',{staticStyle:{"width":"100%","padding-left":"10px"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }